import React, { createContext, useState, useEffect } from "react";
import axiosInstance from "../api/axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // יאחסן {id, email, first_name...} או null
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get("/users/me");
      setUser(res.data);
    } catch (err) {
      // לא מחובר
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // בפעם הראשונה שהאפליקציה נטענת, נבדוק אם יש סשן תקף
    fetchUser();
  }, []);

  const logout = async () => {
    await axiosInstance.post("/users/logout");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout, fetchUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
